import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";

export const Hero = () => {
  const { t, to } = useLang();
  const h = t.home;
  return (
    <section data-testid="hero-section" className="relative max-w-7xl mx-auto px-6 sm:px-12 pt-14 sm:pt-20 pb-20 sm:pb-24">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-7 reveal" style={{ animationDelay: "0.1s" }}>
          <h1 className="font-serif font-medium text-[38.5px] sm:text-[56.5px] lg:text-[67px] leading-[0.98] tracking-tight text-[#1A2522]" data-testid="hero-name">
            {h.nameLine1}
            <br />
            <span className="italic font-normal">{h.nameLine2}</span>
          </h1>
          <div className="mt-8 flex items-center gap-5">
            <span className="divider"></span>
            <p className="font-serif text-xl sm:text-2xl text-[#374F49] tracking-wide">{h.specialty}</p>
          </div>
          <p className="mt-10 text-[13px] sm:text-base tracking-[0.22em] uppercase font-semibold text-[#1A2522] max-w-xl" data-testid="hero-motto">{h.motto}</p>
          <p className="mt-6 max-w-2xl text-[14px] sm:text-[15px] text-[#495854] leading-[1.8] font-light" data-testid="hero-lead">{h.lead}</p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to={to("philosophy")} data-testid="hero-cta-philosophy" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#1A2522] hover:bg-[#374F49] text-[#F8F6F0] text-[12px] tracking-[0.2em] uppercase font-semibold transition-colors">
              {h.ctaPhilosophy} <ArrowUpRight className="w-4 h-4" />
            </Link>
            <Link to={to("cases")} data-testid="hero-cta-cases" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-[#1A2522]/40 hover:border-[#1A2522] text-[#1A2522] text-[12px] tracking-[0.2em] uppercase font-semibold transition-colors">
              {h.ctaCases}
            </Link>
          </div>
        </div>
        <HeroPortrait h={h} />
      </div>
    </section>
  );
};

const HeroPortrait = ({ h }) => (
  <div className="lg:col-span-5 reveal" style={{ animationDelay: "0.3s" }}>
    <div className="relative">
      <div className="absolute -inset-3 rounded-[40px] bg-[#EAE5D9]/70 -z-10"></div>
      <div className="relative overflow-hidden rounded-[32px] aspect-[4/5] bg-[#EAE5D9]">
        <img src="/images/portrait.jpg" alt={h.portraitAlt} data-testid="hero-portrait" className="w-full h-full object-cover" loading="eager" />
      </div>
      <div className="absolute -bottom-6 -left-6 hidden sm:block max-w-[78%] bg-[#1A2522] text-[#F8F6F0] px-6 py-4 rounded-2xl shadow-xl">
        <p className="text-[10px] tracking-[0.28em] uppercase opacity-70 font-semibold">{h.badgeTop}</p>
        <p className="font-serif text-lg mt-1 leading-tight">{h.badgeBottom}</p>
      </div>
    </div>
  </div>
);
